<template>
  <div>
    <div v-if="showClose" class="comp-close">
      <v-btn small text icon @click="close()" :disabled="!$auth.manage || isHistory">
        <icon-svg iconName="comp-close" />
      </v-btn>
    </div>
    <v-card class="proc-component">
      <v-card-title class="proc justify-center darken-1" @dblclick="openRightLayer()">
        <icon-svg :size="procIconSize" iconName="proc-trigger" />
      </v-card-title>
    </v-card>
  </div>
</template>

<script>
import EventBus from '@/vue-caas/views/process/component/event-bus.js';
import IconSvg from '@/vue-caas/components/IconBase.vue';

export default {
  components: {
    IconSvg,
  },
  props: {
    comId: {
      default: '',
    },
    comTp: {
      default: 'TRIG',
    },
    isHistory: {
      default: false,
    },
  },

  data() {
    return {
      procIconSize: 24,
      showClose: false,
      formData: {
        tr_id: '',
        tr_name: '',
        tr_interval: '30',
        tr_interval_tp: 'MM',
      },
      nodeId: '',
      formEmit: {
        comTp: 'TRIG',
        comId: '',
        nodeId: '',
      },
    };
  },

  watch: {
    comId() {
      return this.comId;
    },
  },

  created() {
    this.initialize();
    EventBus.$on('change-component-data', this.changeComponentData);
  },
  methods: {
    resetForm() {
      this.formData = {
        tr_id: '',
        tr_name: '',
        tr_interval: '30',
        tr_interval_tp: 'MM',
      };
      this.formEmit = {
        comId: '',
        nodeId: this.nodeId,
        comName: '',
        comTp: this.comTp,
      };
      EventBus.$emit('set-comp-id', this.formEmit);
    },
    changeComponentData(id, nodeId) {
      if (nodeId === this.nodeId) {
        this.formData.tr_id = id;
        if (!this.formData.tr_id) {
          this.resetForm();
          return;
        }
        this.selectTriggerDetail();
      }
    },
    openRightLayer() {
      EventBus.$emit('open-right-layer', this.formEmit);
    },
    initialize() {
      this.$nextTick(() => {
        this.nodeId = this.$el.parentElement.parentElement.id;
        this.formData.tr_id = this.comId;
        if (this.formData.tr_id !== '') {
          this.selectTriggerDetail();
        } else {
          this.formEmit = {
            comId: '',
            nodeId: this.nodeId,
            comName: '',
            comTp: this.comTp,
          };
          EventBus.$emit('set-comp-id', this.formEmit);
        }
      });
    },
    selectTriggerDetail() {
      const id = this.formData.tr_id;
      let index = this.triggerList.findIndex((e) => e.tr_id == id);
      if (index > -1) {
        this.formData = Object.assign({}, this.triggerList[index]);
        this.formEmit = {
          comId: this.formData.tr_id,
          nodeId: this.nodeId,
          comName: this.formData.tr_name,
          comTp: this.comTp,
        };
        EventBus.$emit('set-comp-id', this.formEmit);
      } else {
        this.resetForm();
      }
    },
    close() {
      EventBus.$emit('close', this.nodeId);
    },
  },
  computed: {
    triggerList() {
      return this.$store.getters.triggerSelectBoxList;
    },
  },
};
</script>
